// The utility-container expired-login-token body shared by sealy and stearns:
// the no-side-nav "promotions ptb" column with a headline-only content title —
// NOT the account side-nav shell `ExpiredTokenBody` renders (cocoon, pillows,
// one800pillows, tempurpedic). Two states, selected server-side by
// email_sent: the sent confirmation paragraph, or the reCAPTCHA-gated
// verification form. All copy arrives pre-localized as props (server-side
// gettext).
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { FormErrorList } from "../../../forms/FormErrorList";
import {
    ReactivatedReCaptchaField,
    useReCaptchaSubmit,
} from "../../../forms/ReactivatedReCaptcha";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "../../../forms/classNames";

type IProps = Immutable<templates.ExpiredTokenDocumentTemplate>;

export const UtilityExpiredTokenBody = (props: IProps): React.JSX.Element => {
    // Hooks must run unconditionally, so resolve the submit handler at the top
    // of the component body (it is only attached in the form state).
    const onSubmit = useReCaptchaSubmit(props.recaptcha_action);
    return (
        <div className="utility">
            <div className="container promotions ptb">
                <div className="content">
                    <div className="content-title">
                        <h1 className="content-title__headline">
                            {props.content_title}
                        </h1>
                    </div>

                    <div className="content__copy--full-width">
                        {props.email_sent ? (
                            <p>{props.sent_message}</p>
                        ) : (
                            <>
                                <p>{props.intro_message}</p>
                                <form
                                    className={FORM_CLASS_NAME}
                                    method="post"
                                    action={props.action_url}
                                    onSubmit={onSubmit}
                                >
                                    <CSRFToken />
                                    {props.errors.length > 0 && (
                                        <div className={FORM_FIELD_CLASS_NAME}>
                                            <FormErrorList
                                                errors={props.errors}
                                            />
                                        </div>
                                    )}
                                    <input
                                        type="hidden"
                                        name="user"
                                        value={props.user_value}
                                    />
                                    <input
                                        type="hidden"
                                        name="next"
                                        value={props.next_value}
                                    />
                                    <ReactivatedReCaptchaField />
                                    <div
                                        className={FORM_FIELD_SUBMIT_CLASS_NAME}
                                    >
                                        <input
                                            type="submit"
                                            className="button button--full-width"
                                            value={props.submit_text}
                                        />
                                    </div>
                                </form>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
